import {Form, Grid, GridColumn, GridRow, Input, Search, SearchResultProps} from "semantic-ui-react";
import React, {FunctionComponent, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../common/store";
import {
  areAddressesLoading,
  getAddresses,
  getCandidateAddresses
} from "../../common/candidateAddresses.slice";
import {SearchProps, SearchResultData} from "semantic-ui-react/dist/commonjs/modules/Search/Search";
import {SearchFilters, updateSearchValue} from "./ap.slice";
import {cancelAddressSearchRequest} from "../../apis/AddressServiceAPI";
import _ from "lodash";
import {APSearchUtils} from "./ap.searchUtil";

type PlacenameSearchBarTypeProps = {
  setSearchFilters: React.Dispatch<React.SetStateAction<SearchFilters>>
  setRadiusChange: any
  defaultRadius: number | undefined
}

let performAddressSearch = _.debounce(
    (value, dispatch) => {
      dispatch(getCandidateAddresses(value))
      dispatch(updateSearchValue(value))
    }, 300, {
      leading: true,
      trailing: true,
    },
)
const APPlacenameSearchBar = ({setSearchFilters, setRadiusChange, defaultRadius}: PlacenameSearchBarTypeProps) => {

  const dispatch = useAppDispatch()
  const isLoading = useAppSelector(areAddressesLoading)
  const candidateAddresses = useAppSelector(getAddresses)
  const [ searchValue, setSearchValue] = useState("")

  const handleSearchChange = (e: React.MouseEvent<HTMLElement>, { value }: SearchProps) => {
    let text = String(value)
    setSearchValue(text)
    cancelAddressSearchRequest()
    if (value && value.length >= 3) {
      performAddressSearch(value, dispatch)
    }
  }

  const handleResultSelect = (e: React.MouseEvent<HTMLDivElement>, { result }: SearchResultData) => {
    setSearchValue (result.title)
    setSearchFilters({latitude: result.latitude, longitude: result.longitude, address: result.title})
  }

  const ResultRenderer = ({ title, description }: SearchResultProps) => {
    if ( title === undefined ) { title = '' }
    let key = 'searchResult-' + title.replace(/\s/g, '_')
    return (
        <div key={key}>
          <div className={'parcelSearchResultItem float-left'}>{title}</div>
          <div className={'description float-right'}>{description}</div>
        </div>
    )
  }

  return (
      <Grid columns={2} style={{paddingTop: "0px"}}>
        <GridRow columns={1}>
          <GridColumn>
            <div className={"field"} style={{margin: "0px"}}>
              <label> Placename Search </label>
            </div>
            <Search className={'apAdvancedSearch'}
                      placeholder="Enter place name details"
                      loading={isLoading}
                      onResultSelect={handleResultSelect}
                      onSearchChange={handleSearchChange}
                      results={APSearchUtils.getResultsMatching(candidateAddresses, 'PLACENAMES')}
                      resultRenderer={ResultRenderer}
                      size={'huge'}
                      value={searchValue}
                      noResultsMessage="No aerial photographs found"
                      noResultsDescription="Enter placename details"
                      minCharacters={3}
                      input={<Input input={{ spellCheck: 'false', type: 'search' }} />}
              />
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn>
            <Form.Field control={Input} label="Radius (in metres)" defaultValue={defaultRadius} type="number"
                        name={'radius'} min="1" max="10000" onChange={setRadiusChange} />
          </GridColumn>
        </GridRow>
      </Grid>
  )
}

export default APPlacenameSearchBar